import React, { useState, useRef } from 'react';
import Cropper from 'react-cropper';
import './SearchFace.css'; // <-- ¡NUEVA LÍNEA!
//import 'cropperjs/dist/cropper.css'; // Importa los estilos de la librería Cropper



// Este componente recibe la URL de la API y la función para reportar resultados.
function SearchFace({ apiUrl, onResults }) {

    // --- ESTADOS ---
    // [CONCEPTO REACT: useState]
    const [file, setFile] = useState(null); // Almacena el objeto File original.
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null); // URL Base64 para mostrar la imagen en el Cropper.
    const [loading, setLoading] = useState(false); // Estado de carga.
    const [error, setError] = useState(null); // Mensajes de error.
    const [cropperKey, setCropperKey] = useState(0); // Estado para forzar la renderización

    // [CONCEPTO REACT: useRef]
    // useRef crea una referencia mutable que no causa renderizado. Se usa para acceder
    // directamente a elementos del DOM o, en este caso, al objeto Cropper.
    const cropperRef = useRef(null);

    // src/SearchFace.js (cerca de la línea 30)

    // --- MANEJADOR DE ARCHIVOS ---
    const handleFileChange = (e) => {
        setError(null);

        if (!e.target.files || e.target.files.length === 0) {
            return;
        }

        const selectedFile = e.target.files[0];

        setFile(selectedFile);

        const reader = new FileReader();
        reader.onloadend = () => {
            setImagePreviewUrl(reader.result);
            // ¡MODIFICACIÓN CLAVE AQUÍ!
            // Incrementamos la clave para forzar la re-inicialización del Cropper.
            setCropperKey(prevKey => prevKey + 1);
        };
        reader.readAsDataURL(selectedFile);
    };

    // --- LÓGICA DE RECORTE Y ENVÍO ---
    const handleCropAndSearch = async () => {
        if (!imagePreviewUrl) {
            setError('Por favor, selecciona una foto primero.');
            return;
        }

        const cropper = cropperRef.current.cropper;
        // 1. Obtener el Canvas con la imagen recortada.
        const croppedCanvas = cropper.getCroppedCanvas({
            width: 800, // [IMPORTANTE] Redimensiona a un ancho máximo de 800px para reducir el payload
            height: 800,
            imageSmoothingQuality: 'high',
        });

        // 2. Convertir el Canvas a Base64.
        // Usamos calidad 0.8 (80%) para comprimir la imagen recortada, asegurando que sea pequeña.
        const base64Image = croppedCanvas.toDataURL('image/jpeg', 0.8);

        // 3. Extraer solo la cadena Base64 (quitamos 'data:image/jpeg;base64,').
        const base64String = base64Image.split(',')[1];

        // [VALIDACIÓN FINAL DE TAMAÑO]
        // Base64 aumenta 33% el tamaño. 1MB de Base64 es suficiente para la búsqueda.
        const sizeInMB = (base64String.length / 1024 / 1024);
        if (sizeInMB > 1.5) { // Establecemos un límite seguro de 1.5 MB para el payload final.
            setError(`La imagen recortada sigue siendo demasiado grande (${sizeInMB.toFixed(2)} MB). Por favor, intenta un recorte más pequeño.`);
            return;
        }


        // --- INICIO DEL FETCH ---
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    image_data: base64String
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || `Error del servidor (${response.status})`);
            }

            if (data && Array.isArray(data.results)) {
                onResults(data.results);
            } else {
                onResults([]);
            }

        } catch (err) {
            setError(err.message || 'Error al conectar con el API Gateway.');
            onResults(null);
        } finally {
            setLoading(false);
            // setFile(null); // Opcional: limpiar la imagen después de la búsqueda
            // setImagePreviewUrl(null); 
        }
    };

    // --- RENDERIZADO (JSX) ---
    return (
        <div className="search-face-container">
            <p>Selecciona una foto, ajusta el recuadro para centrar tu rostro y busca.</p>

            {/* 1. Input de archivo para seleccionar la foto */}
            <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                disabled={loading}
                className="file-input"
            />

            {/* 2. Contenedor de la herramienta Cropper */}
            {imagePreviewUrl && (
                <div className="cropper-area">
                    {/* El componente Cropper de react-cropper */}
                    <Cropper
                        // ¡MODIFICACIÓN CLAVE AQUÍ!
                        zoomable={false} // Remueve la funcion de zoom con el mouse!
                        key={cropperKey} // Forzamos la re-renderización cuando cambia la imagen.
                        ref={cropperRef}
                        src={imagePreviewUrl}
                    // ... (el resto de las props se quedan igual)
                    />
                </div>
            )}

            {/* 3. Botón de búsqueda */}
            <button
                onClick={handleCropAndSearch}
                disabled={loading || !imagePreviewUrl}
                className="search-button-face primary-action-button"
            >
                {loading ? 'Recortando y Buscando...' : 'Recortar y Buscar Rostro'}
            </button>

            {/* Muestra mensajes de error */}
            {error && <div className="error-message">{error}</div>}
        </div>
    );
}

export default SearchFace;